import { CommonMainPage } from '../../widgets/utility/CommonMainPage'
import { OrganicResultsFilters } from './widgets/organic-results-filters/OrganicResultsFilters'
import { useAppSelector } from '../../app/store/hooks/Redux'
import { selectCountry, selectProject } from './model/organicResultsSlice'
import { PreparingDataStub } from '../../lib/widgets/stubs/PreparingDataStub'
import clsx from 'clsx'
import { MissingKeywordsStub } from '../../lib/widgets/stubs/MissingKeywordsStub'
import { StubLayout } from '../../lib/widgets/stubs/StubLayout'

import styles from './OrganicResultsPage.module.scss'
import { OrganicResultsTable } from './widgets/organic-results-table/OrganicResultsTable'
import { ActionsSlotProvider } from '../../shared/components/utility/actions-slot/ActionsSlot'
import { useTranslation } from 'react-i18next'
import { useMenuLayout } from '../../app/layouts/main-layout/hooks/UseMenuLayout'

export const OrganicResultsPage = () => {
  const { t } = useTranslation()
  const { menuLayout } = useMenuLayout()
  const { value: projectId, has_seo_links: hasSeoLinks } = useAppSelector(selectProject)
  const currentCountry = useAppSelector(selectCountry)

  const showKeywordStub = currentCountry?.keywords_state === 'never'

  const state = showKeywordStub ? 'keyword-stub' : hasSeoLinks ? 'table' : 'project-stub'

  // заглушка встаёт после gap колонки страницы
  const stubGap = menuLayout === 'top' ? 50 : 24

  const content = {
    'keyword-stub': (
      <StubLayout gap={stubGap}>
        <MissingKeywordsStub project={projectId} />
      </StubLayout>
    ),
    table: <OrganicResultsTable />,
    'project-stub': (
      <StubLayout gap={stubGap}>
        <PreparingDataStub />
      </StubLayout>
    ),
  }[state]

  return (
    <CommonMainPage hint={t('navigation.hint.organicSearch')} title={t('navigation.organicSearch')}>
      <ActionsSlotProvider>
        <section
          className={clsx(styles.wrapper, menuLayout === 'top' ? 'gap-[50px]' : 'gap-[24px]')}
        >
          <OrganicResultsFilters />
          {content}
        </section>
      </ActionsSlotProvider>
    </CommonMainPage>
  )
}
